import { useEffect, useState } from 'react';
import { matchesMedia } from '../../utils/breakpoints';

// Live result of a media query (pass one of MEDIA from utils/breakpoints), so layout
// follows the viewport width rather than the device type.
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => matchesMedia(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    const update = () => setMatches(mql.matches);
    update();
    if (mql.addEventListener) mql.addEventListener('change', update);
    else mql.addListener(update);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', update);
      else mql.removeListener(update);
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
